import { render, staticRenderFns } from "./wasteExchangeBedConfirm.vue?vue&type=template&id=6189c426&scoped=true"
import script from "./wasteExchangeBedConfirm.vue?vue&type=script&lang=js"
export * from "./wasteExchangeBedConfirm.vue?vue&type=script&lang=js"
import style0 from "./wasteExchangeBedConfirm.vue?vue&type=style&index=0&id=6189c426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189c426",
  null
  
)

export default component.exports